import React, { useState } from "react";
import { DataContext } from "../../../helper/HelperOne";
import NavBar from "../../nav_bar/Navbar";
import QuotationLossReasonList from "./QuotationLossReasonList";

const QuotationLossReason = () => {
    const [searchUi, setSearchUi] = useState(false);
    const [searchData, setSearchData] = useState(null);

    return (
        <DataContext.Provider
            value={{ searchUi, setSearchUi, searchData, setSearchData }}
        >
            <NavBar childrenPage={<QuotationLossReasonList />} menuId={6} />
        </DataContext.Provider>
    )
}

export default QuotationLossReason